module.exports = __webpack_public_path__ + "img/box.303f3ded.png";